import { globalSettings } from './configuration';
import { getAuthToken } from './browser_state';
import { getTenantId, isUsingPathBasedTenancy } from './tenant';

const base_url = globalSettings.PORTAL_API_URL;

export const apiFetch = async (endpoint, options = {}) => {
    const url = endpoint.startsWith('http') ? endpoint : `${base_url}${endpoint}`;

    const headers = { ...options.headers };

    const token = await getAuthToken();
    if (token) {
        headers['Authorization'] = `Token ${token}`;
    }

    headers['X-Source-Host'] = window.location.host;

    if (isUsingPathBasedTenancy()) {
        try {
            const tenantId = await getTenantId(base_url);
            if (tenantId) headers['X-Tenant-ID'] = tenantId;
        } catch (e) {
            console.error('Failed to resolve tenant ID:', e);
        }
    }

    if (options.body && !(options.body instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
    }

    return fetch(url, { ...options, headers });
};

export const apiGet = (endpoint, options = {}) =>
    apiFetch(endpoint, { method: 'GET', ...options });

export const apiPost = (endpoint, body, options = {}) => {
    const fetchOptions = { method: 'POST', ...options };
    fetchOptions.body = body instanceof FormData ? body : JSON.stringify(body);
    return apiFetch(endpoint, fetchOptions);
};

export const apiPut = (endpoint, body, options = {}) => {
    const fetchOptions = { method: 'PUT', ...options };
    fetchOptions.body = body instanceof FormData ? body : JSON.stringify(body);
    return apiFetch(endpoint, fetchOptions);
};

export const apiPatch = (endpoint, body, options = {}) => {
    const fetchOptions = { method: 'PATCH', ...options };
    fetchOptions.body = body instanceof FormData ? body : JSON.stringify(body);
    return apiFetch(endpoint, fetchOptions);
};

export const apiDelete = (endpoint, options = {}) =>
    apiFetch(endpoint, { method: 'DELETE', ...options });

export default apiFetch;
